var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarbonCreditMeterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#7ED63F",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13380_7976)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9015 45.2935H16.812C16.1857 45.2637 15.6489 44.9953 15.2314 44.6076C14.8138 44.1602 14.5454 43.5638 14.5454 42.9375C14.5454 35.8991 17.4085 29.5466 22.0013 24.9239C26.624 20.3311 32.9765 17.468 39.985 17.468C47.0234 17.468 53.3759 20.3311 57.9687 24.9239C62.5914 29.5466 65.4545 35.8991 65.4545 42.9375C65.4545 43.5638 65.1861 44.1602 64.7387 44.6076C64.3212 45.0251 63.7545 45.2935 63.1282 45.2935H63.0686H63.0388H16.9313H16.9015Z",
    fill: "#91BED4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5937 45.2936H36.4062C35.9588 44.6076 35.6904 43.8024 35.6904 42.9375C35.6904 40.5516 37.629 38.613 39.985 38.613C42.3709 38.613 44.3095 40.5516 44.3095 42.9375C44.3095 43.8024 44.0411 44.6076 43.5937 45.2936Z",
    fill: "#83ABBF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9911 44.0709C16.9613 44.0709 16.9314 44.0709 16.9016 44.0709C16.2753 44.0709 15.7683 43.5639 15.7683 42.9376C15.7683 29.5765 26.654 18.7207 39.9852 18.7207C53.3462 18.7207 64.202 29.5765 64.202 42.9376C64.202 43.5639 63.695 44.0709 63.0687 44.0709C63.0389 44.0709 63.0091 44.0709 63.0091 44.0709C47.6499 44.0709 32.3205 44.0709 16.9911 44.0709Z",
    fill: "#D9F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.1604 44.0708H35.8395C35.7501 43.6831 35.6904 43.3252 35.6904 42.9375C35.6904 40.5516 37.629 38.613 39.985 38.613C42.3709 38.613 44.3095 40.5516 44.3095 42.9375C44.3095 43.3252 44.2498 43.6831 44.1604 44.0708Z",
    fill: "#C3DADA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.8521 18.7505C39.2398 18.7207 39.6275 18.7207 39.9854 18.7207C40.3731 18.7207 40.7608 18.7207 41.1187 18.7505V22.3294C41.1187 22.9557 40.6117 23.4627 39.9854 23.4627C39.3591 23.4627 38.8521 22.9557 38.8521 22.3294V18.7505Z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.1094 21.4048C51.7655 21.7627 52.4216 22.1504 53.0777 22.5381L51.2585 25.6696C50.9602 26.2064 50.2743 26.3853 49.7076 26.0871C49.1708 25.759 48.9919 25.0731 49.3199 24.5363L51.1094 21.4048Z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.3548 29.845C60.7723 30.4713 61.16 31.1274 61.5179 31.8133L58.3864 33.6028C57.8496 33.9308 57.1636 33.7519 56.8356 33.1852C56.5373 32.6484 56.7163 31.9625 57.2531 31.6344L60.3548 29.845Z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9224 22.5381C27.5487 22.1504 28.2048 21.7627 28.8907 21.4048L30.6802 24.5363C31.0082 25.0731 30.7994 25.759 30.2626 26.0871C29.7258 26.3853 29.0398 26.2064 28.7118 25.6696L26.9224 22.5381Z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4822 31.8133C18.8401 31.1274 19.1979 30.4713 19.6155 29.845L22.747 31.6344C23.2838 31.9625 23.4627 32.6484 23.1347 33.1852C22.8364 33.7519 22.1505 33.9308 21.5838 33.6028L18.4822 31.8133Z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.0899 39.4187C55.5829 39.4187 55.1057 39.0608 54.9864 38.5538C53.2865 31.6347 47.113 26.8032 39.9851 26.8032C32.8572 26.8032 26.7136 31.6347 25.0136 38.5538C24.8645 39.1502 24.2382 39.538 23.6417 39.3888C23.0154 39.2397 22.6575 38.6134 22.8066 38.0169C24.7452 30.0838 31.8134 24.5366 39.9851 24.5366C48.1866 24.5366 55.2549 30.0838 57.1934 38.0169C57.3425 38.6134 56.9548 39.2397 56.3583 39.3888C56.2689 39.4187 56.1794 39.4187 56.0899 39.4187Z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.7446 43.0272C41.3568 43.0272 40.999 42.8483 40.7604 42.4606C40.4621 41.9237 40.6411 41.2378 41.1779 40.9097L48.3654 36.794C48.9022 36.466 49.5882 36.6449 49.9163 37.1818C50.2145 37.7484 50.0355 38.4344 49.4987 38.7326L42.3112 42.8781C42.1323 42.9974 41.9533 43.0272 41.7446 43.0272Z",
    fill: "#83ABBF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.985 46.099C38.2553 46.099 36.8237 44.6675 36.8237 42.9377C36.8237 41.1781 38.2553 39.7466 39.985 39.7466C41.7446 39.7466 43.1762 41.1781 43.1762 42.9377C43.1762 44.6675 41.7446 46.099 39.985 46.099Z",
    fill: "#91BED4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.6199 62.5019C46.4568 62.5019 45.3235 62.2633 44.22 61.8458C41.9534 60.9511 41.2675 59.4003 41.0885 58.267C40.671 55.553 42.8183 52.4215 45.0253 50.6321C45.9498 49.8567 47.1129 49.3199 48.3357 48.7532C50.8409 47.5603 53.197 46.4568 53.9426 43.5639C54.0619 43.027 54.4794 42.6393 54.9864 42.5499C55.5232 42.4604 56.0302 42.699 56.3285 43.1463C60.981 50.2146 56.3881 57.1933 56.2092 57.4916C56.1794 57.5214 56.1794 57.5214 56.1495 57.5512C53.0777 61.637 49.7971 62.5019 47.6199 62.5019Z",
    fill: "#7ED63F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.7465 61.4284C39.1202 61.4284 38.5834 60.981 38.4641 60.3547C38.315 59.639 38.7922 58.953 39.5079 58.8039C41.0886 58.5057 42.1921 58.0285 42.2815 57.9987V57.9688H42.3113H42.3412C42.4008 57.939 42.4306 57.939 42.4605 57.9092C42.6991 57.8496 45.5621 56.925 48.2164 55.0461C48.8129 54.6286 49.648 54.7479 50.0953 55.3742C50.5129 55.9707 50.3638 56.8057 49.7673 57.2233C46.8446 59.2811 43.8025 60.2951 43.2955 60.4442C42.9376 60.5933 41.6851 61.1003 40.0149 61.4284C39.9255 61.4284 39.836 61.4284 39.7465 61.4284Z",
    fill: "#378B4E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9344 62.502C30.8291 62.502 31.7238 62.3529 32.5589 61.995C34.3483 61.3091 34.8851 60.1161 35.0044 59.2512C35.3325 57.1337 33.6624 54.6882 31.9624 53.3163C31.2168 52.7198 30.3221 52.3023 29.3677 51.8549C27.4292 50.9304 25.61 50.0655 25.0433 47.7989C24.9538 47.4112 24.6258 47.113 24.2082 47.0533C23.8205 46.9638 23.403 47.1428 23.1644 47.5007C19.5557 52.9882 23.1346 58.4162 23.2837 58.6249C23.2837 58.6547 23.3135 58.6547 23.3135 58.6846C25.6994 61.8459 28.2344 62.502 29.9344 62.502Z",
    fill: "#7ED63F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0482 61.6964C36.5254 61.6964 36.9728 61.3385 37.0622 60.8614C37.1517 60.2947 36.7938 59.7579 36.2272 59.6386C35.0044 59.4298 34.1395 59.0421 34.0799 59.0123H34.0501L34.0202 58.9825C33.9904 58.9825 33.9606 58.9825 33.9308 58.9526C33.7518 58.893 31.5449 58.207 29.4572 56.7457C29.0098 56.3878 28.3537 56.5071 28.0257 56.9843C27.6976 57.4316 27.8169 58.0878 28.2643 58.4158C30.5309 60.0263 32.8869 60.8017 33.3045 60.921C33.5729 61.0403 34.5571 61.428 35.8395 61.6666C35.8991 61.6964 35.9886 61.6964 36.0482 61.6964Z",
    fill: "#378B4E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13380_7976"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50.9091,
    height: 50.9091,
    fill: "white",
    transform: "translate(14.5454 14.5454)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbonCreditMeterIcon);
export default __webpack_public_path__ + "static/media/carbon-credit-meter-icon.072a6fa83467b79136302b59940a4f7a.svg";
export { ForwardRef as ReactComponent };